import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserInformationResponseModel } from '@global-models/Response/UserInformationResponseModel';
import { ApiSendService } from '@global-services/ApiSend.service';
import { ApiUrlEnum } from '@global-models/ApiUrlEnum';
import { environment } from '../../../../environments/environment';
import { DashboardItemResponseModel } from '@global-models/Response/DashboardItemResponseModel';
import { UserFirmsResponseModel } from '@global-models/Response/UserFirmsResponseModel';
import { AppConfig } from '@shared-configs/app-config';
import { AppHelper } from '@shared-helpers/app-helper';
import { AuthenticationService } from '@auth-services/authentication.service';
import { TokenModel } from '@auth-models/Request/TokenRequestModel';
import { UserResponseModel } from '@auth-models/Response/UserResponseModel';
declare let mLayout: any;

@Component({
  selector: 'app-header-nav',
  templateUrl: './header-nav.component.html',
  styleUrls: ['./header-nav.component.css'],
  encapsulation: ViewEncapsulation.None,
})

export class HeaderNavComponent implements OnInit, AfterViewInit {
  public _headerDashboardItemResponseModel: DashboardItemResponseModel;
  public selectedFirm: UserFirmsResponseModel = new UserFirmsResponseModel();
  public user = AppConfig.userModel;
  public firmList: Array<UserFirmsResponseModel> = new Array<UserFirmsResponseModel>();
  public information: Array<UserInformationResponseModel> = new Array<UserInformationResponseModel>();
  public Logo: string;
  public isShowSearchBar: boolean = true;

  constructor(private _authService: AuthenticationService,
    private _router: Router,
    private _apiservice: ApiSendService) {
    this._headerDashboardItemResponseModel = (JSON.parse(localStorage.getItem('DashboardItems')) as DashboardItemResponseModel);
    this.GetUserAuthenticatedFirms();
  }

  ngOnInit() {
    AppConfig.setUser();
    this.user = AppConfig.userModel;

    this.Logo = './assets/app/media/img/logos/logoPortal_New_Default.png';
    if (environment.Key === 'VBTDEV') { this.Logo = './assets/app/media/img/logos/logoPortal_New_Dev.png'; }
    else if (environment.Key === 'VBTTEST') { this.Logo = './assets/app/media/img/logos/logoPortal_New_Test.png'; }
    else if (environment.Key === 'VBTPROD') { this.Logo = './assets/app/media/img/logos/logoPortal_New.png'; }
    else if (environment.Key.includes('SANKO')) { this.Logo = './assets/app/media/img/logos/SankoBeyazLogo.png'; }

    if (environment.Key.includes('EBILET')) { this.isShowSearchBar = false; }

    if (this._headerDashboardItemResponseModel === null && this._headerDashboardItemResponseModel === undefined) {
      this._headerDashboardItemResponseModel = new DashboardItemResponseModel();
    }
  }

  public GetUserAuthenticatedFirms() {

    const firmList = localStorage.getItem('firmList');

    if (AppHelper.IsNullOrEmpty(firmList)) {
      return this._apiservice.GetAuthorization(ApiUrlEnum.BackOffice, '/api/User/GetUserAuthenticatedFirms')
        .then((response) => {

          const firms = ((response || new Array<UserFirmsResponseModel>()) as Array<UserFirmsResponseModel>);

          if (AppHelper.HasRows(firms)) {
            this.firmList = firms;
            localStorage.setItem('firmList', JSON.stringify(firms));

            const userModel = JSON.parse(localStorage.getItem('DashboardUser')) as UserResponseModel;

            if (!AppHelper.IsNullOrUndefined(userModel)) {
              const selectedFirm = this.firmList.filter(x => x.FirmId === userModel.FirmId)[0];

              if (!AppHelper.IsNullOrUndefined(selectedFirm)) {
                this.selectedFirm = selectedFirm;
              }
              else {
                this.SetSelectedFirm();
              }
            }
            else {
              this.SetSelectedFirm();
            }

            localStorage.setItem('selectedFirm', JSON.stringify(this.selectedFirm));
            return true;

          } else {
            return false;
          }

        }).catch(ex => {
          this.firmList = new Array<UserFirmsResponseModel>();
          return false;
        });
    } else {
      this.firmList = (JSON.parse(localStorage.getItem('firmList')) || new Array<UserFirmsResponseModel>()) as Array<UserFirmsResponseModel>;
      this.selectedFirm = (JSON.parse(localStorage.getItem('selectedFirm')) || new UserFirmsResponseModel()) as UserFirmsResponseModel;
    }
  }

  SetSelectedFirm() {
    const isDefaulFirmList = this.firmList.filter(x => x.IsDefaultFirm === true);
    if (isDefaulFirmList.length > 0) {
      this.selectedFirm = isDefaulFirmList[0];
    }
    else {
      this.selectedFirm = this.firmList[0];
    }

    this.UserAuthenticatedFirmsChange(this.selectedFirm);
  }

  public UserAuthenticatedFirmsChange(event: any) {
    if (event.FirmId !== 0) {
      this.selectedFirm = this.firmList.find(x => x.FirmId === event.FirmId);
      localStorage.setItem('selectedFirm', JSON.stringify(this.selectedFirm));
      const passModel = (JSON.parse(localStorage.getItem('DashboardPass')) as TokenModel);
      passModel.FirmId = this.selectedFirm.FirmId;
      this._authService.changeFirm(passModel.Email, passModel.FirmId)
        .then(result => {
          this._router.navigate(['/']);
        }).catch(error => {
          this._authService.logout();
        });

    }
    else if (AppHelper.HasRows(this.firmList)) {
      this.selectedFirm = this.firmList[0];
      localStorage.setItem('selectedFirm', JSON.stringify(this.selectedFirm));
      const passModel = (JSON.parse(localStorage.getItem('DashboardPass')) as TokenModel);
      passModel.FirmId = this.selectedFirm.FirmId;
      this._authService.changeFirm(passModel.Email, passModel.FirmId)
        .then(result => {
          this._router.navigate(['/']);
        }).catch(error => {
          this._authService.logout();
        });
    }

  }

  ngAfterViewInit() {
    mLayout.initHeader();
  }

}
